<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="totalAmount">
            <span class="totalAmount_title">实发金额</span>
            <span class="moneys">￥{{ form.salary }}</span>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30" v-if="!allShopFlag">
              <div class="itemName">门店名称</div>
              <div class="itemNum">{{ shopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">月份</div>
              <div class="itemNum">{{ formatMonth(form.reportMonth) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">本店出勤</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.shopWorkDay }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>客诉</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">客诉件数</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.complainActualNumber }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实发金额</div>
              <div class="itemNum">￥{{ form.complainAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>离职率考核</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">离职率</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.quitRate }}%</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实发金额</div>
              <div class="itemNum">￥{{ form.quitAmount }}</div>
            </div>
          </div>
          <div>
            <p class="order-title-boxs"><span class="blueBlock"></span><i>修脚数考核</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30">
                <div class="itemName">实际月均修脚数</div>
                <div class="itemNum" v-if="allShopFlag">-</div>
                <div class="itemNum" v-else>{{ form.avgFootTotal }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">本月增长率</div>
                <div class="itemNum" v-if="allShopFlag">-</div>
                <div class="itemNum" v-else>{{ form.footIncreaseRate }}%</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">实发金额</div>
                <div class="itemNum">{{ form.footAmount }}</div>
              </div>
            </div>
          </div>

          <div>
            <p class="order-title-boxs"><span class="blueBlock"></span><i>{{ Number(reportMonth.substring(0, 4)) < newVersion ? '康复率考核':'修护成功率' }}</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30">
                <div class="itemName">{{ Number(reportMonth.substring(0, 4)) < newVersion ? '康复率':'修护成功率' }}</div>
                <div class="itemNum" v-if="allShopFlag">-</div>
                <div class="itemNum" v-else>{{ form.rehabilitationRate }}%</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">实发金额</div>
                <div class="itemNum">{{ form.rehabilitationAmount }}</div>
              </div>
            </div>
          </div>

          <div v-if="Number(reportMonth.substring(0, 4)) >= newVersion">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>会员充值增长率</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30">
                <div class="itemName">本月增长率</div>
                <div class="itemNum" v-if="allShopFlag">-</div>
                <div class="itemNum" v-else>{{ form.rechargeIncreaseRate || 0 }}%</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">实发金额</div>
                <div class="itemNum">{{ form.rechargeIncreaseAmount }}</div>
              </div>
            </div>
          </div>

          <div v-if="Number(reportMonth.substring(0, 4)) < newVersion">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>工资增长率考核</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30">
                <div class="itemName">本月增长率</div>
                <div class="itemNum" v-if="allShopFlag">-</div>
                <div class="itemNum" v-else>{{ form.salaryIncreaseRate }}%</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">实发金额</div>
                <div class="itemNum">{{ form.salaryIncreaseAmount }}</div>
              </div>
            </div>
          </div>

          <p class="order-title-boxs"><span class="blueBlock"></span><i>品质战考核</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">一期得分</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.qualityFirstScore }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">二期得分</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.qualitySecondScore }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">三期得分</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.qualityThirdScore }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">四期得分</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.qualityFourScore }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">五期得分</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.qualityFiveScore }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实发金额</div>
              <div class="itemNum">￥{{ form.qualityAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="Number(reportMonth.substring(0, 4)) < newVersion"><span class="blueBlock"></span><i>其他</i></p>
          <div class="totals-box pl24" v-if="Number(reportMonth.substring(0, 4)) < newVersion">
            <div class="flex-row mb30">
              <div class="itemName">提成小计</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.commissionSubtotal }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">标准自挣提成</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.standardSelfDeductAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">应达标自挣提成</div>
              <div class="itemNum" v-if="allShopFlag">-</div>
              <div class="itemNum" v-else>{{ form.selfDeductAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="!allShopFlag"><span class="blueBlock"></span><i>备注信息</i></p>
          <div class="totals-box pl24" v-if="!allShopFlag">
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
          </div>
          <div class="drawer-footer pr24 pb10">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "工资详情",
      dialogHide: false,
      shopName: '',
      allShopFlag: false,
      form: {
        staffSalaryBaseInfoBo: {},
        staffSalaryCommissionInfoBo: {},
        staffSalaryQualityInfoBo: {},
        staffSalaryReduceInfoBo: {},
        staffSalarySubsidyInfoBo: {},
      },
      dialogHide: false,
      userInfo: {
        shopBizConfig: {

        }
      },
      reportMonth: '',
      newVersion: '2025'
    };
  },
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function (org) {
        this.userInfo = this.$store.getters.ShopInfo;
        this.shopName = org.shopName;
        this.allShopFlag = org.allShopFlag;
        this.reportMonth = org.dataMonth
        this.$api.post(this.$url.staffKpiSalary.get, {
          staffId: this.userInfo.staffId,
          reportMonth: org.dataMonth,
          allShopFlag: org.allShopFlag
        }).then(res => {
          if (res) {
            this.addEditShow = true;
            this.form = res;
          }
        }).catch(error => { });
      });
    },
    back() {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

/deep/ div .el-drawer__body {
  padding: 0 !important;
}

.totalAmount {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin: 20px 0 0 0;

  .totalAmount_title {
    display: inline-block;
    width: 120px;
    min-width: 100px;
    padding-left: 24px;
    margin-right: 80px;
  }
}

.staffSubsidy {
  margin-bottom: 30px;
  margin-right: 24px;
  text-align: center;
  border-top: 1px solid #333;
  border-left: 1px solid #333;

  .el-col {
    font-size: 14px;
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #333;
    border-right: 1px solid #333;
  }
}
</style>